import { useContext } from 'react'; //, useEffect, useState

import { GameContext, ViewContext } from '@/state/contexts';
import { performActionType } from '@/type/performAction';
import { cardPurchaseRequiresDecision } from '@/util/card';
import { carbonStolenThisTurn } from '@lc/const/modifiers';
import {
	buyBattery,
	buyFactory,
	buyPR,
	donateEnergy,
	stealCarbon,
	storeEnergy,
} from '@lc/const/socketEvent';
import '@/style/HandModal.css';
import '@/style/UI.css';
import {
	calculateBatteryCost,
	calculateFactoryCost,
} from '@lc/lib/playermat_helper';

const ActionModal = ({ resetPaymentObject, onClose }) => {
	const {
		currPlayer,
		myState,

		activePlayerId,

		setSelectedAction,
		selectedAction,
		setSelectedActionCost,

		selectedCardId,

		performAction,
	}: any = useContext(GameContext);

	const performActionTyped = performAction as performActionType;

	const {
		showPaymentModal,
		setShowPaymentModal,

		setShowDecisionModal,

		pPE,
		pPC,
	}: any = useContext(ViewContext);

	/**
	 * Socket Functions
	 */
	function clientStoreEnergy() {
		performActionTyped(storeEnergy);
		//socket.emit(storeEnergy, currPlayer);
		// TODO modify payment modal to a "storeModal", add chars from factory array row, hit reset to not commit.
		// server, check that arrays are valid, move it around
		// launchPaymentModalWithParameters("donateEnergy", 1);
		onClose();
	}

	function clientStealCarbon() {
		performActionTyped(stealCarbon);
		onClose();
	}

	function clientBuyBattery() {
		const batteryCost = calculateBatteryCost(myState);
		launchPaymentModalWithParameters(buyBattery, batteryCost);
		onClose();
	}

	function clientBuyFactory() {
		const factoryCost = calculateFactoryCost(myState);
		launchPaymentModalWithParameters(buyFactory, factoryCost);
		onClose();
	}

	function clientBuyPR() {
		launchPaymentModalWithParameters(buyPR, 2);
		onClose();
	}

	function clientDonateEnergy() {
		launchPaymentModalWithParameters(donateEnergy, 1);
		onClose();
	}

	/**
	 * UI functions
	 */

	function launchPaymentModalWithParameters(action, cost) {
		setSelectedAction(action);
		setSelectedActionCost(cost);
		showPayment(); // launch payment modal
		onClose();
	}

	function postPaymentDecisionCheck() {
		let makeDecision = false;
		if (
			selectedAction === 'playCard' ||
			selectedAction === 'playSummitCard'
		) {
			// determine if card needs decision here
			makeDecision = cardPurchaseRequiresDecision(selectedCardId);
		}

		if (makeDecision) {
			requestDecisionForCard(); // close PaymentModal and goto DecisionModal
			return;
		}

		// clientAction(selectedAction);
		resetPaymentObject();
	}

	function showPayment() {
		let paymentBool = showPaymentModal;
		setShowPaymentModal(!paymentBool);
		onClose();
	}

	const requestDecisionForCard = () => {
		setShowPaymentModal(false);
		setShowDecisionModal(true);
		onClose();
	};

	return (
		<div className="modal" onClick={onClose}>
			<div
				className="modal-content-action"
				onClick={(e) => e.stopPropagation()}
			>
				<span className="close" onClick={onClose}>
					&times;
				</span>
				{/* Break out into its own modal that pops up when you hit button "player action"(?)*/}
				{activePlayerId === currPlayer.playerId && (
					<div className="actionButtonContainer">
						<button
							className="split-button"
							value={0}
							onClick={clientDonateEnergy}
							disabled={pPE <= 0}
						>
							<span className="left-text">❤️ Donate Energy</span>
						</button>
						<button
							className="split-button"
							value={0}
							onClick={clientStealCarbon}
							disabled={myState.modifiers.includes(
								carbonStolenThisTurn
							)}
						>
							<span className="left-text">⬛ Steal Carbon</span>
							<span className="right-text">-1 Card</span>
						</button>
						<button
							className="split-button"
							value={0}
							onClick={clientBuyPR}
							disabled={pPE + pPC < 2}
						>
							<span className="left-text">👪 Buy PR</span>
							<span className="right-text">-2 Energy</span>
						</button>
						<button
							className="split-button"
							value={0}
							onClick={clientBuyFactory}
							disabled={pPE + pPC < calculateFactoryCost(myState)}
						>
							<span className="left-text">🏭 Buy Factory</span>
							<span className="right-text">
								-{calculateFactoryCost(myState)} Energy
							</span>
						</button>
						<button
							className="split-button"
							value={0}
							onClick={clientBuyBattery}
							disabled={
								pPE + pPC < (myState.batteries >= 1 ? 2 : 1)
							}
						>
							<span className="left-text">🔋 Buy Battery</span>
							<span className="right-text">
								-{myState.batteries >= 1 ? 2 : 1} Energy
							</span>
						</button>
						<button
							className="split-button"
							value={0}
							onClick={clientStoreEnergy}
							disabled={
								pPE <= 0 ||
								// WRONG WRONG WRONG TODO TODO
								// I NEED MYYYYY STATE. MYYSPACE. BE MY FRINED
								// need to get MY player's state, not the array position
								myState.batteries ===
									myState.batteryEnergyArr.length
							}
						>
							<span className="left-text">
								⚡ Store Energy On Battery
							</span>
						</button>
					</div>
				)}
			</div>
		</div>
	);
};

export default ActionModal;
